export const TEXT_TYPES = {
    ORDER: "Order",
    CONTENT_TYPE: "Content Type",
    FILE: "File",
    ADD_CUSTOM_FONTMATTER :"Add Custom Front Matter",
    CUSTOM_TOC: "CustomTOCPage",
    CUSTOM_TITLE: "CustomTitlePage",
    CUSTOM_COPYRIGHT: "CustomCopyrightPage",
    CUSTOM_FONTMATTER: "CustomFrontMatter",
    CONTENT_SOURCE_FILE: "File",
    CONTENT_SOURCE_CUSTOM: "Custom",
    FILE_STATUS_SYSTEM: "System",
    FILE_STATUS_LOCKED: "Locked"
};
export const USER_ROLE = {
    salesRepresentative: 'Sales Rep',
    LSA: 'LSA',
    Instructor: 'Instructor'
};
export const ETEXT_STATUSES = {
    PRODUCT_CREATION: 'Product Record sent to PDZ:',
    INITIAL_CONTENT_PROCESSING: 'PDF sent to eText Optimization:',
    CONTENT_PROCESS_STATUS: 'CITE TOC Manifest received:',
    CONTENT_PUBLISH_MSG: 'CITE TOC Manifest sent to CSG and PLA:',
    INDEX_BUILD_COMPLETED: 'CSG Indexed for In-content Search:',
    SEED_COMPLETED: 'PLA data ready for instructor Dashboard:',
    INSTANT_PURCHASE_OFFER: 'Instant Purchase Offer Created:',
    INVITE_EMAIL: 'Instructor Invite Email Ready to be Sent:'
};
export const MESSAGES = {
    default_success: "Your changes have been saved",
    default_failed: "Your changes were not saved",
    access_code_save_success: "Acccess Code Save Success",
    access_code_save_failed: "Acccess Code Save Failed",
    access_code_send_pcs_success: "Send Access Code To PDH Success",
    access_code_send_pcs_failed: "Send Access Code To PDH Failed",
    access_code_isbn_generate_success: "Access Code ISBN generated Successfully",
    access_code_isbn_generate_failed: "Access Code ISBN generation Failed",
    course_contact_save_success : "Instructor Save Success",
    course_contact_save_failed : "Instructor Save Failed",
    institution_save_success : "Institution Save Success",
    institution_save_failed : "Institution Save Failed",
    order_details_save_success : "Order details save success",
    order_details_save_failed : "Save failed order details",
    part_delete_success: "Part Delete Success",
    part_delete_failed: "Part Delete Failed",
    resource_move_success: "Resource Move Success",
    resource_move_failed: "Resource Move Failed",
    resource_delete_success: "Resource Delete Success",
    resource_delete_failed: "Resource Delete Failed",
    send_to_pcs_success: "Send To PDH Success",
    send_to_pcs_failed: "Send To PDH Failed",
    book_rebuild_started: "Book rebuild started",
    unable_to_start_book_rebuild: "Unable to start book rebuild",
    book_already_send_to_build: "Error Collection Rebuild in progress. Please wait till the rebuild collection completes",
    book_has_both_om_and_3p: "Original Material (OM) and Third Party Material (3P) are included in this Collection.",
    book_has_om: "Original Material (OM) is included in this Collection.",
    book_has_blueprint_msg_part1: "Blueprint included: ",
    book_has_blueprint_msg_part2: "_blueprint",
    fail_message: "Error occurred. Please try again later.",
    upload_pdf_error: "Unable to add resource.",
    print_rental_content_match: "Print Rental Pilot Content: "
};
export const MESSAGE_TYPES = {
    default: {styleClass:'message_default',icon: false},
    error: {styleClass:'message_error',icon: 'warning-18'},
    warning: {styleClass:'message_warning',icon: 'warning-18'},
    success: {styleClass:'message_success',icon: 'check-lg-18'},
    info: {styleClass:'message_info',icon: false},
};



// WEBPACK FOOTER //
// ./src/constants/APP_CONSTANTS.js